import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop/Backdrop';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  progressModal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  progressRoot: {
    outline: 'none'
  },
  backdropRoot: {
    backgroundColor: 'rgba(255, 255, 255, 0.2)'
  }
});

const ProgressFullscreen = ({ open = true }) => {
  const classes = useStyles();
  return (
    <Modal
      className={classes.progressModal}
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 1500,
        classes: {
          root: classes.backdropRoot
        }
      }}
    >
      <Fade
        in={open}
        timeout={{
          enter: 300,
          exit: 200
        }}
        style={{ transitionDelay: '500ms' }}
      >
        <CircularProgress
          size={40}
          thickness={2}
          color="secondary"
          classes={{ root: classes.progressRoot }}
        />
      </Fade>
    </Modal>
  );
};

ProgressFullscreen.propTypes = {
  open: PropTypes.bool
};

export default ProgressFullscreen;
